<template>
  <div id="app">
    <MobileHeader v-if="!isAdminPage" />
    <TopBanner v-if="!isAdminPage" @open-register="openFloatingRegister" />
    <main class="main-content" :class="{ 'with-header': !isAdminPage }">
      <router-view />
    </main>
    <FooterSection v-if="!isAdminPage" />
    <MobileFloatingBar v-if="!isAdminPage" ref="floatingBar" />
  </div>
</template>

<script>
import TopBanner from '@/components/TopBanner.vue'
import MobileFloatingBar from '@/components/MobileFloatingBar.vue'
import MobileHeader from '@/components/MobileHeader.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'App',
  components: { TopBanner, MobileFloatingBar, MobileHeader, FooterSection },
  computed: {
    isAdminPage() {
      return this.$route.path.startsWith('/admin')
    }
  },
  methods: {
    openFloatingRegister() {
      if (this.$refs.floatingBar) {
        this.$refs.floatingBar.openRegister()
      }
    }
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css');
@import url('https://cdn.jsdelivr.net/gh/webfontworld/score/SCoreDream.css');

:root {
  /* Typography — 둥근 친근한 톤 */
  --font-sans: 'Pretendard Variable', 'Pretendard', -apple-system, sans-serif;
  --font-rounded: 'S-Core Dream', 'Pretendard Variable', 'Pretendard', sans-serif;
  --font-pretendard: var(--font-sans);

  /* Legacy aliases — 모두 둥근 산세리프로 통합 */
  --font-serif-kr: var(--font-rounded);
  --font-serif-en: var(--font-rounded);
  --font-display: var(--font-rounded);
  --font-mono-disp: var(--font-sans);

  /* 카시아 속초 — Brand Palette (딥 네이비 + 골드 / 5성급 럭셔리 톤) */
  --le-noir: #0A1C33;
  --le-ink: #12243F;
  --le-charcoal: #1E3555;
  --le-graphite: #3A4E6B;
  --le-warm-grey: #8A8577;
  --le-pearl: #F3ECDD;
  --le-bone: #E9DFC8;
  --le-cream: #F9F5EC;
  --le-white: #FFFFFF;

  /* Gold accent (텍스트 / 라인 / 강조) — CASSIA 골드 */
  --le-champagne: #B4924E;
  --le-champagne-light: #CBAE66;
  --le-champagne-dark: #8A6D2E;
  --le-gold-line: rgba(180, 146, 78, 0.36);
  --le-gold-line-soft: rgba(180, 146, 78, 0.18);

  /* Gold (alias) */
  --le-orange: #B4924E;
  --le-orange-light: #CBAE66;
  --le-orange-dark: #8A6D2E;

  /* Legacy mapping for existing components */
  --primary: var(--le-noir);
  --primary-light: var(--le-ink);
  --primary-dark: #000000;
  --sub-color: var(--le-pearl);
  --text-color: #3A3A3A;
  --white: #ffffff;
  --font-family: var(--font-sans);
  --font-family2: var(--font-serif-en);
  --font-family4: var(--font-serif-kr);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--le-ink);
  background: #ffffff;
  /* 한글은 어절(단어) 단위로 줄바꿈 — 단어가 중간에서 잘리지 않도록 전역 적용 */
  word-break: keep-all;
  overflow-wrap: break-word;
}

html, body {
  overflow-x: hidden;
  width: 100%;
  background: #ffffff;
}

img { display: block; max-width: 100%; }

.main-content.with-header {
  padding-top: 60px;
}

body.has-top-banner .main-content.with-header {
  padding-top: 120px;
}

#app {
  overflow-x: hidden;
  width: 100%;
}

/* ==================== 데스크톱 모바일 프레임 ====================
   화면이 프레임보다 넓어지면 콘텐츠를 500px 컬럼으로 가운데 정렬,
   상단/하단 고정바도 같은 컬럼 폭에 맞춰 재배치한다. */
:root { --frame-max: 500px; }

@media (min-width: 540px) {
  html {
    background:
      radial-gradient(ellipse at 50% -10%, #23324b 0%, #141b28 55%, #0c111b 100%);
    background-attachment: fixed;
  }
  #app {
    max-width: var(--frame-max);
    margin: 0 auto;
    background: #ffffff;
    min-height: 100vh;
    box-shadow: 0 0 80px rgba(0, 0, 0, 0.4);
  }
  /* 고정 요소를 중앙 컬럼에 맞춰 재배치 (transform은 애니메이션용으로 남겨둠) */
  .mobile-header,
  .top-banner,
  .mobile-floating-bar {
    left: calc(50% - (var(--frame-max) / 2)) !important;
    right: auto !important;
    width: var(--frame-max) !important;
  }
}
</style>
